import { useState, useEffect } from 'react'
import EditAdtrExpenditure from './editAdtrExpenditure'
import Spinner from 'react-bootstrap/Spinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import BaseService from '../../../services/BaseService'
import DataGrid from '../../GenericComponents/DataGrid'
import { Column } from 'primereact/column'
import CommonService from "../../../services/CommonService"

const SearchResultContainer = (props) => {
  const [editAdtrExpenditures, setEditAdtrExpenditures] = useState(false);
  const [selectedExpenditureInfo, setSelectedExpenditureInfo] = useState([]);
  const {adtrProceedId} = props;
  const [adtrExpenditures, setAdtrExpenditures] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  
  const viewEditFormatter = (row) => {
    return (
      <div style={{
        textAlign: "left",
        lineHeight: "normal"
      }}>
        <FontAwesomeIcon icon={faPencilAlt} className="custom-icon" onClick={(e)=>onRowClick(e, row)}/> 
      </div>
    );
  }
  const onRowClick = (e, row) => {
    // e.preventDefault();
    console.log(row);
    setSelectedExpenditureInfo(row);
    setEditAdtrExpenditures(true);
  }

  //get adtr proceed expenditures when Finalsale, adtr, or proceed changes to refresh that adtr proceed expenditure edit list
  const getExpenditureByProceedId = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAdtrExpendituresByProceed",
      hdrStruct: null,
      queryParam: null,
      reqData: {
          "adtrProceedId": adtrProceedId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setAdtrExpenditures(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (adtrProceedId) {
      getExpenditureByProceedId();
    }
    // eslint-disable-next-line
  }, [adtrProceedId]);

  const columns = [{
    dataField: 'purposeDesc',
    text: 'Purpose Description',
    sort: true,
  },{
    dataField: 'spentAmt',
    text: 'Spent Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.spentAmt),
  },{
    dataField: "",
    text: "Action",
    formatter: viewEditFormatter,
  }
  ];

  const handleModalClose = () => {
    setEditAdtrExpenditures(false);
    getExpenditureByProceedId()
  }

  return (
    <>
      <hr/>
      {isLoading && <Spinner animation="border" variant="primary" />}
      <div className="form">
        <h2>Search Result: </h2>
        <DataGrid
            title="Annual Debt Transparency Reports Proceed Expenditures"
            dataSource={adtrExpenditures}
            sortField='purposeDesc'   
            searchToolTip="Use the search feature to quickly retrieve the system code values"
            emptyDataMessage='No data available to display'
            >
            {columns.map((column, i) => {
                return (
                <Column 
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort} 
                body={column.formatter}
                hidden={column.hidden}
                />)
                }) 
            } 
        </DataGrid>
      </div>
      {editAdtrExpenditures && <EditAdtrExpenditure onModalClose={() => handleModalClose()} adtrExpenditureInfo={selectedExpenditureInfo} />}
    </>
  )
}

export default SearchResultContainer
